const component = "program-icon";

export const programIcon = {
  component,
  calendarIcon: `${component}/calendar-icon`,
};
